(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cg-dept-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // --- Mobile bottom-sheet filters ---
    var sheet = document.getElementById('cg-dept-filters');
    var backdrop = document.getElementById('cg-filters-backdrop');
    var openBtn = document.getElementById('cg-filters-open');
    var closeBtn = document.getElementById('cg-filters-close');
    var grabZone = document.getElementById('cg-filters-top');
    function setSheet(open) {
      if (!sheet) return;
      // Clear any leftover drag transform so the CSS class controls position.
      sheet.classList.remove('is-dragging');
      sheet.style.transform = '';
      backdrop.hidden = !open;
      // force a frame so the transition runs after unhiding
      requestAnimationFrame(function () {
        sheet.classList.toggle('is-open', open);
        backdrop.classList.toggle('is-open', open);
      });
      document.body.style.overflow = open ? 'hidden' : '';
      // The promo widget is hidden behind the sheet via this body class.
      document.body.classList.toggle('cg-filters-open', open);
    }
    if (openBtn) openBtn.addEventListener('click', function () { setSheet(true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setSheet(false); });
    if (backdrop) backdrop.addEventListener('click', function () { setSheet(false); });

    // --- Swipe down on the top zone to close the sheet ---
    if (sheet && grabZone) {
      var dragStartY = 0;
      var dragDelta = 0;
      var dragging = false;
      var CLOSE_THRESHOLD = 110; // px pulled down before it closes on release
      grabZone.addEventListener('touchstart', function (e) {
        if (!sheet.classList.contains('is-open')) return;
        dragStartY = e.touches[0].clientY;
        dragDelta = 0;
        dragging = true;
        sheet.classList.add('is-dragging');
      }, { passive: true });
      grabZone.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        dragDelta = e.touches[0].clientY - dragStartY;
        if (dragDelta < 0) dragDelta = 0; // only track downward pulls
        sheet.style.transform = 'translateY(' + dragDelta + 'px)';
      }, { passive: true });
      function endDrag() {
        if (!dragging) return;
        dragging = false;
        sheet.classList.remove('is-dragging');
        sheet.style.transform = '';
        if (dragDelta > CLOSE_THRESHOLD) {
          setSheet(false);
        }
      }
      grabZone.addEventListener('touchend', endDrag);
      grabZone.addEventListener('touchcancel', endDrag);
    }

    // --- Sort (keeps current filters in the URL) ---
    var sort = document.getElementById('cg-sort-select');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }

    // --- Filter groups: search + show all/less (Concept B) ---
    document.querySelectorAll('.cg-filter-group').forEach(function (group) {
      var list = group.querySelector('[data-cg-list]');
      if (!list) return;
      var moreBtn = group.querySelector('[data-cg-more]');
      var search = group.querySelector('[data-cg-fsearch]');
      function extras() { return list.querySelectorAll('.cg-fopt-extra'); }
      if (moreBtn) {
        moreBtn.addEventListener('click', function () {
          var expanded = list.classList.toggle('is-expanded');
          extras().forEach(function (li) { li.hidden = !expanded; });
          moreBtn.textContent = expanded ? 'Show less' : ('+ Show all ' + list.querySelectorAll('li').length);
        });
      }
      if (search) {
        search.addEventListener('input', function () {
          var q = search.value.trim().toLowerCase();
          if (!q) {
            list.querySelectorAll('li').forEach(function (li) {
              li.hidden = li.classList.contains('cg-fopt-extra') && !list.classList.contains('is-expanded');
            });
            if (moreBtn) moreBtn.hidden = false;
            return;
          }
          if (moreBtn) moreBtn.hidden = true;
          list.querySelectorAll('li').forEach(function (li) {
            li.hidden = li.textContent.toLowerCase().indexOf(q) === -1;
          });
        });
      }
    });

    // --- Load more (fetch next page of this section, append cards) ---
    function bindLoadMore() {
      var btn = document.getElementById('cg-load-more');
      if (!btn || btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        btn.setAttribute('aria-busy', 'true');
        var url = new URL(btn.href, window.location.origin);
        url.searchParams.set('section_id', btn.dataset.sectionId);
        fetch(url.toString())
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newItems = doc.querySelectorAll('#cg-dept-grid-list > li');
            var list = document.getElementById('cg-dept-grid-list');
            newItems.forEach(function (li) { list.appendChild(li); });
            var next = doc.getElementById('cg-load-more');
            if (next) {
              btn.href = next.href;
              btn.removeAttribute('aria-busy');
            } else {
              var wrap = btn.closest('.cg-dept-loadmore');
              if (wrap) wrap.remove();
            }
          })
          .catch(function () {
            window.location.assign(btn.href);
          });
      });
    }
    bindLoadMore();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-dept-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var desc = document.getElementById('cg-dept-desc');
    if (!desc) return;
    var toggle = desc.querySelector('.cg-dept-desc__toggle');
    if (!toggle) return;
    toggle.hidden = false;
    toggle.addEventListener('click', function () {
      var open = desc.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.querySelector('[data-more]').hidden = open;
      toggle.querySelector('[data-less]').hidden = !open;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
